export { InsightsQuotaTooltip } from './InsightsQuotaTooltip';
